import { modals } from '@mantine/modals';
import { Nedry } from './Nedry';

// Single source of truth for "how Nedry appears" — used by the 403 interceptor and by the `nedry`
// secret code. At most one modal is ever shown: `open` (cleared on close) blocks stacking when
// forbidden requests keep arriving, and a 1.5s debounce additionally collapses a burst. Pass
// force=true for a deliberate summon so it ignores the debounce (but still never stacks).
let lastNedryAt = 0;
let open = false;

export function showNedry(force = false) {
    if (open) return;
    if (!force && Date.now() - lastNedryAt < 1500) return;
    lastNedryAt = Date.now();
    open = true;
    modals.open({
        centered: true,
        withCloseButton: true,
        size: 'auto',
        title: "Ah ah ah! You didn't say the magic word!",
        children: <Nedry />,
        onClose: () => { open = false; },
    });
}
